export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-local-dark.93b71bcb565254c2474944eda6dca314.png";